import Vue from 'vue'
import request from '@/utils/request'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import echarts from "echarts";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'
import { render, validatePictureSize, validatePictureWidthHeight } from './utils/pictureUtil'
import VueQuillEditor from 'vue-quill-editor'
var _ = require('lodash')

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

function renderVideo(id) {
  return request({
    url: `/file/renderVideo/${id}`,
    method: 'get',
  })
}

function dictShow(dict, value) {
  if (_.isEmpty(value)) {
    return '-';
  }
  for (let index in dict) {
    let item = dict[index];
    if (item.value == value) {
      return item.label;
    }
  }
  return value;
}

function replace(value, suffix, replace = '-',) {
  if (suffix && value) {
    let ret = value || replace;
    return ret + "  " + suffix
  }
  return value || replace
}

function formatMoney(money, digit) {
  var tpMoney = '0.00';
  if (undefined != money) {
    tpMoney = money;
  } else {
    return money;
  }
  tpMoney = new Number(tpMoney);
  if (isNaN(tpMoney)) {
    return '0.00';
  }
  tpMoney = tpMoney.toFixed(digit) + '';
  var re = /^(-?\d+)(\d{3})(\.?\d*)/;
  while (re.test(tpMoney)) {
    tpMoney = tpMoney.replace(re, "$1,$2$3")
  }

  return tpMoney;
}
function toFormData(data) {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return formData;
}
Vue.prototype.$echarts = echarts;
Vue.prototype._toFormData = toFormData; 
Vue.prototype._ds = dictShow;
Vue.prototype._rp = render;
Vue.prototype._rpV = renderVideo;
Vue.prototype._vps = validatePictureSize;
Vue.prototype._vwh = validatePictureWidthHeight;
Vue.prototype._fm = formatMoney;
Vue.prototype._WIDTH = 100000
Vue.prototype._HEIGHT = 100000
Vue.prototype._NONNULL = replace
Vue.prototype._ = _;
Vue.use(ElementUI, { locale })
Vue.use(VCharts)
Vue.use(VueQuillEditor, /* { default global options } */)
Vue.config.productionTip = false


new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js